"use client";

import { ChevronDown, Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { cn } from "../lib/utils";
import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

const themes = [
  {
    theme: "light",
    label: "Light",
    icon: Sun,
  },
  {
    theme: "dark",
    label: "Dark",
    icon: Moon,
  },
  {
    theme: "system",
    label: "System",
    icon: Monitor,
  },
] as const;

export function ThemeSelector() {
  const { setTheme, theme, resolvedTheme } = useTheme();

  const currentTheme = themes.find((t) => t.theme === theme) ?? themes[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm">
          <span>
            <currentTheme.icon className="inline-block size-4" />{" "}
            {currentTheme.label}
          </span>
          <ChevronDown
            className={cn(
              resolvedTheme === "dark" ? "text-white" : "text-black",
            )}
          />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {themes.map((theme) => (
          <DropdownMenuItem
            key={theme.theme}
            onClick={() => setTheme(theme.theme)}
          >
            <theme.icon
              className={cn(
                "size-4",
                resolvedTheme === "dark" ? "text-white" : "text-black",
              )}
            />
            {theme.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
